// extracted by mini-css-extract-plugin
module.exports = {"main_loadingComponent":"LoadingComponent_main_loadingComponent__H61dO"};